// import React from "react";
// import { Check } from "react-bootstrap-icons";
// import "./WhyCertification.css";

// const WhyCertification = () => {
//   return (
//     <section className="why-certification">
//       <div className="container my-5">
//         <div className="row align-items-center">
//           {/* Left Side */}
//           <div className="col-lg-6 col-md-12 why-main-heading mb-4 mb-lg-0">
//             <h2 className="fw-bold">Why Certification Matters</h2>
//             <p>
//               Certification goes beyonds credentials, it opens doors to global
//               opportunities, builds expertise and meets industry demand for
//               skilled professionals.
//             </p>
//             <ul className="cert-list">
//               <li>
//                 <Check /> Boost your career with globally recognized credentials 
//               </li>
//               <li>
//                 <Check /> High demand for certified professionals in India and
//                 beyond
//               </li>
//               <li>
//                 <Check /> AMPP certifications valued across industries worldwide
//               </li>
//               <li>
//                 <Check /> Play a vital role in safeguarding critical
//                 infrastructure
//               </li>
//             </ul>
//           </div>

//           {/* Right Side */}
//           <div className="col-lg-6 col-md-12 d-flex flex-column justify-content-center why-cert-start">
//             <div className="row text-center align-items-stretch g-4">
//               <div className="col-md-6 border-end-md">
//                 <h3>$ 2.5 Trillion</h3>
//                 <p className="small-text">Annual global cost of corrosion</p>
//               </div>
//               <div className="col-md-6">
//                 <h3>40%</h3>
//                 <p className="small-text">
//                   Increase in demand for certified inspectors over the next decade
//                 </p>
//               </div>
//               <div className="col-12">
//                 <h3>150+ countries</h3>
//                 <p className="small-text">
//                   Where AMPP credentials are recognized worldwide.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default WhyCertification;

import React from "react";
import { Check } from "react-bootstrap-icons";
import "./WhyCertification.css";

const WhyCertification = () => {
  return (
    <section className="why-certification">
      <div className="container my-5">
        <div className="row align-items-center">
          {/* Left Side */}
          <div className="col-lg-6 col-md-12 why-main-heading mb-md-4 mb-lg-0">
            <h2 className="fw-bold">Why Certification Matters</h2>
            <p>
              Certification goes beyonds credentials, it opens doors to global
              opportunities, builds expertise and meets industry demand for
              skilled professionals.
            </p>
            <ul className="cert-list">
              <li>
                <Check /> Boost your career with globally recognized credentials 
              </li>
              <li>
                <Check /> High demand for certified professionals in India and
                beyond
              </li>
              <li>
                <Check /> AMPP certifications valued across industries worldwide
              </li>
              <li>
                <Check /> Play a vital role in safeguarding critical
                infrastructure
              </li>
            </ul>
          </div>

          {/* Right Side */}
          <div className="col-lg-6 col-md-12 d-flex flex-column justify-content-center why-cert-start">
            <div className="row text-center align-items-stretch g-4">
              <div className="col-md-6 border-end-md">
                <h3>$ 2.5 Trillion</h3>
                <p className="small-text">Annual global cost of corrosion</p>
              </div>
              <div className="col-md-6">
                <h3>40%</h3>
                <p className="small-text">
                  Increase in demand for certified inspectors over the next decade
                </p>
              </div>
              <div className="col-12">
                <h3>150+ countries</h3>
                <p className="small-text">
                  Where AMPP credentials are recognized worldwide.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyCertification;
